import { useCallback } from 'react';
import { searchProducts } from '../../services/claimsService';
import type { ClaimActor, Product } from '../../types/claims.types';

/** Returnerer en stabil async søgefunktion. Tom/blank query → [] uden netværkskald. */
export function useProductSearch(actor: ClaimActor | null): (query: string) => Promise<Product[]> {
  const actorKey = actor ? String(actor.employeeId) : '';
  return useCallback(
    async (query: string) => {
      const q = query.trim();
      if (!q || !actor) return [];
      return searchProducts(q);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [actorKey]
  );
}
